import { useRouteError, useNavigate } from 'react-router-dom';
import { ErrorPageView } from './ErrorPageView';

const ErrorPage = () => {
  const error = useRouteError() as any;
  const navigate = useNavigate();
  console.error(error);

  return <ErrorPageView error={error} onNavigate={() => navigate('/')} />;
};

export default ErrorPage;
